var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "a1a7edc990"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "68cbfe9b1a"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a1a7edc990)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "b3755576f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 649 1 L 649 649 L 1 649 Z M 1 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1358ffc1ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 325 1 C 146.058594 1 1 146.058594 1 325 C 1 503.941406 146.058594 649 325 649 C 503.941406 649 649 503.941406 649 325 C 649 146.058594 503.941406 1 325 1 Z M 325 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3fee287585"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 650,
    y: 0,
    height: 650
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb404dfece"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 133.164062 268.0625 L 332 268.0625 L 332 541.8125 L 133.164062 541.8125 Z M 133.164062 268.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5109848568
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 306 268.0625 L 505 268.0625 L 505 541.8125 L 306 541.8125 Z M 306 268.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a083a70f43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 478 268.0625 L 676.914062 268.0625 L 676.914062 541.8125 L 478 541.8125 Z M 478 268.0625 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#68cbfe9b1a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 80, 80)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3fee287585)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b3755576f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1358ffc1ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M 1 1 L 649 1 L 649 649 L 1 649 Z M 1 1 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb404dfece)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7abf5b",
    d: "M 133.476562 541.929688 L 230.738281 541.929688 L 331.3125 403.902344 L 230.703125 268.0625 L 133.40625 268.0625 L 227.308594 405.410156 Z M 133.476562 541.929688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5109848568)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5b792e",
    d: "M 400.609375 405.410156 L 306.738281 268.0625 L 404 268.0625 L 504.570312 403.902344 L 404.035156 541.929688 L 306.808594 541.929688 Z M 400.609375 405.410156 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a083a70f43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#292929",
    d: "M 572.628906 405.410156 L 478.757812 268.0625 L 576.019531 268.0625 L 676.59375 403.902344 L 576.058594 541.929688 L 478.828125 541.929688 Z M 572.628906 405.410156 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrows);
export default __webpack_public_path__ + "static/media/RightArrows.5730300dd9984b45895904a1271a94fd.svg";
export { ForwardRef as ReactComponent };